import type { FC } from "react";

export interface KemHealthUnavailableBannerProps {
  visible: boolean;
}

const KemHealthUnavailableBanner: FC<KemHealthUnavailableBannerProps> = ({
  visible,
}) =>
  visible ? (
    <div className="text-red-600 p-4 text-center text-sm">
      Kem is currently unavailable. Please try again later.
    </div>
  ) : null;

export default KemHealthUnavailableBanner;
